import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=4f4eee6c&scoped=true"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4eee6c",
  null
  
)

/* custom blocks */
import block0 from "./OrgTree.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports